<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title">
          <a-icon type="file-search" />&nbsp;Search
        </div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" :disabled="triggerSearch" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    :disabled="triggerSearch"
                    v-model="searchDate"
                    format="DD-MM-YYYY"
                    allowClear
                  />
                </div>

                <!-- <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    :disabled="triggerSearch"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatus"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div> -->
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
         :tabbed="true"
         :loading="loading"
         title="Credit Card Reconcile"
         dataDraftTitle="Draft"
         dataListTitle="List"
         createLink="CCCreateReconciliation"
         manifestLink="CCManifestReconciliation"
         editLink="klaim-direktur-edit"
         draftEditLink="CCCreateDraftReconciliation"
         :dataList="searching"
         :draftList="draft"
         :allowcancel="true"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import GlobalMethod from "@/mixins/GlobalMethod.js";

export default {
  name: "klaim-directur-list",
  mixins: [GlobalMethod],
  data() {
    return {
      draft: [],
      list: [],
      search: "",
      loading: false,
      searchDate: [null,null],
      status: undefined,
      triggerSearch: false,
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getScreen","getDefaultDateFormat","getStatus",]),
    searching() {
      let self = this;
      let output = this.list;
      if (this.search) {
        output = output.filter(
                (obj) =>
                (obj.title && obj.title.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.subdesc[0] && obj.subdesc[0].toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.subdesc[1] && obj.subdesc[1].toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.subdesc[2] && obj.subdesc[2].toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
                (obj.subdesc[3] && obj.subdesc[3].toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
        );
      }

      if (this.searchDate!=null && this.searchDate[0]!=null && this.searchDate[1]!=null) {
        output = output.filter((obj) => 
          obj.subdesc[0] &&
          moment(obj.subdesc[0],"DD-MM-YYYY").format("YYYY-MM-DD") >= moment(this.searchDate[0]).format("YYYY-MM-DD") &&
          moment(obj.subdesc[0],"DD-MM-YYYY").format("YYYY-MM-DD") <= moment(this.searchDate[1]).format("YYYY-MM-DD")
        );
      }

      if (this.status) {
        output = output.filter(
                (obj) =>
                        obj.status && obj.status.toLowerCase().indexOf(self.status) >= 0
        );
      }

      return output;
    },
  },
  created() {
    this.fetch();
  },
  mounted(){
    Event.$on("callbackTab", this.clickTabed);
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("callbackTab", this.clickTabed);
    Event.$off("handleCancel", this.canceltrans);
  },
  methods: {
    moment,
    async fetch() {
      this.loading = true
      const lst = await axios.get(this.$serviceUrl + "kartu_kredit/recon", {
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        },
        params: {
          tlc: this.getAuth.username,
        }
      });

      const drf = await axios.get(this.$serviceUrl + "kartu_kredit/recon", {
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        },
        params: {
          tlc: this.getAuth.username,
          isdraft: '1'
        }
      });

      Promise.all([lst, drf])
        .then((res) => {
          this.list = res[0].data.list;
          this.draft = res[1].data.list ? res[1].data.list : undefined;

          if (this.list !== undefined) {
            this.list = [];
            res[0].data.list.forEach((data) => {
              this.list.push({
                title: data.no_rekon,
                subdesc: [
                  this.moment(data.create_dt,this.getStandartFormatDate).format(this.getDefaultDateFormat),
                  this.moment(data.periode,'YYYY-MM').format('MMM YYYY').toUpperCase(),
                  'Card No : '+data.no_kartu+" ( "+data.user_kartu+" )",
                  'No Billing : '+data.no_billing,
                  'Description : '+data.deskripsi,
                ],
                id: data.id_rekon_cc_hdr,
                type: 'manifest',
              });
            });
          }else {
            this.list = [];
          }

          if (this.draft !== undefined ) {
            this.draft = [];
            res[1].data.list.forEach((data) => {
              this.draft.push({
                title: null,
                subdesc: [
                  this.moment(data.create_dt,this.getStandartFormatDate).format(this.getDefaultDateFormat),
                  this.moment(data.periode,'YYYY-MM').format('MMM YYYY').toUpperCase(),
                  'Card No : '+data.no_kartu+" ( "+data.user_kartu+" )",
                  'No Billing : '+data.no_billing,
                  'Description : '+data.deskripsi,
                ],
                id: data.id_rekon_cc_hdr,
                type: 'manifest',
              });
            });
          }else {
            this.draft = [];
          }

          this.loading = false
        })
        .catch((err) => {
          console.error(err);
        });
    },
    clickTabed(val){
      this.search = "";
      this.searchDate = undefined;
      this.status = undefined;
      if (val=="draft"){
        this.triggerSearch = true;
      }else{
        this.triggerSearch = false;
      }
    },
    canceltrans(item) {
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "klaim_cc",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go(0);
          //this.fetchData();
          //this.searching;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
};
</script>

<style>
</style>